import React from 'react'
import _ from 'lodash'

import * as reviewerCommentType from './reviewerCommentType'
import useLookupService from '../../../../../services/lookup/useLookupService'
import useWebService from '../../../../../services/web/useWebService'
import authenStore from '../../../../../stores/authen/authenStore'
import useLoading from '../../../../../control/loading/useLoading'
import checkPermission from '../../../../../utilities/checkPermission'
import useAppFolderAndTabAction from '../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import useTranslate from '../../../../../i18n/useTranslate'
import useFolderAndTab from '../../useFolderAndTab'
import useManageProjectStore from '../../../../../stores/manageProject/useManageProjectStore'

import { useHistory } from 'react-router-dom'
import { RoutePath } from '../../../../../router/routesConfig'
import { CommentaryProjectType } from '../../../../../services/web/types/requestWebServiceTypes'
import { TabSelectedType } from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import { topicIsExempt, topicIsUploadComment } from '../../../../../constants/constants'
import { DialogType } from '../../../../../control/dialog/dialog'
import constUserGroup from '../../../../../constants/userGroup'
import { DatasourceForCopyToClipbaord } from '../../../../../control/copyToClipboard/copyToclipboard'
import { ResultDocumentTopicLut } from '../../../../../services/lookup/types/responseLookupServiceTypes'
import * as REQServiceTypes from '../../../../../services/web/types/requestWebServiceTypes'
import submittedStep from '../../../../../constants/submittedStep'
import { convertDateToFormatTH } from '../../../../../utilities/date'
import useCommentaryAction from '../../../../../stores/commentary/useCommentaryAction'
import useAppAlertMessageAction from '../../../../../stores/appAlertMessage/appAlertMessageAction'
import { GetProjectResultType } from '../../../../../services/web/types/responseWebServiceTypes'
import committeeProjectRole from '../../../../../constants/committeeProjectRole'
import useChecklistStore from '../../../../../stores/checklist/useChecklistStore'
import { DatasourceForExport } from '../../../../../control/exportToMSWord/exportToMSWord'
import useChecklistAction from '../../../../../stores/checklist/useChecklistAction'

const useReviewerComment = (props: reviewerCommentType.UseReviewerComment) => {
    const { callbackSaveComplete, isOneComment = false } = props
    const translate = useTranslate()
    const callLookup = useLookupService()
    const callWebService = useWebService()
    const profileStore = authenStore()
    const [isShowSubComment, setIsShowSubComment] = React.useState<boolean>(false)
    const [initialValues, setInitialValues] = React.useState<any>({})
    const [commentTitleList, setCommentTitleList] = React.useState<reviewerCommentType.ResultType[]>([])
    const [initialComment, setInitialComment] = React.useState<reviewerCommentType.CommentType[]>([])
    const [director, setDirector] = React.useState<reviewerCommentType.OptType[]>([])
    const [commentaryProject, setCommentaryProject] = React.useState<any>()
    const isCommitteeInfo = React.useRef<reviewerCommentType.CommitteeInfo[]>([])
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = React.useRef<Record<string, Function>>()
    const directorRef = React.useRef<reviewerCommentType.OptType>()
    const formRef = React.useRef<any>()
    const isDirectorEmptyRef = React.useRef<boolean>(false)
    const checkPermissionHook = checkPermission()
    const { projectData } = useManageProjectStore()
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const [isRequired, setIsRequired] = React.useState<boolean>(false)
    const isLanguageRef = React.useRef<string>()
    const [textRemaining, setTextRemaining] = React.useState<number[]>([])
    const [textRemainingRemark, setTextRemainingRemark] = React.useState<number>()
    const paramsRef = React.useRef<any>()
    const [documentTopic, setDocumentTopic] = React.useState<ResultDocumentTopicLut[] | null>([])
    const [initialUploadFile, setInitialUploadFile] = React.useState<any>()
    const isDeadlineRef = React.useRef<boolean>(false)
    const latestFormValuesRef = React.useRef<any>()
    const hasAutoSavedDataRef = React.useRef(false)

    const appFolderAndTabAction = useAppFolderAndTabAction()
    const loadingHook = useLoading()
    const appAlertMessageAction = useAppAlertMessageAction()
    const history = useHistory()
    const tabAndFolderHook = useFolderAndTab()
    const [dataSourceForCopyToClipboard, setDataSourceForCopyToClipboard] = React.useState<
        DatasourceForCopyToClipbaord[]
    >([])
    const [dataSourceForExport, setDataSourceForExport] = React.useState<DatasourceForExport[]>([])
    const [dataForShowUpdateDate, setDataForShowUpdateDate] = React.useState<{
        nameTH: string
        nameEN: string
        date: string
    }>()

    const commentaryAction = useCommentaryAction()
    const showSaveDraft = checkPermissionHook.checkSaveDraft()

    const checklistState = useChecklistStore()
    const checklistStateRef = React.useRef(checklistState)
    checklistStateRef.current = checklistState
    const { clearChecklist } = useChecklistAction()

    React.useEffect(() => {
        if (
            profileStore?.profile.userId &&
            checkPermissionHook.isCommitteeInProject(projectData?.committeeInfo ?? [])
        ) {
            getCommentaryProjectCommitteeByID(profileStore?.profile.userId)
            checkIsDeadLine()
        }
    }, [profileStore?.profile.userId ?? null])

    React.useEffect(() => {
        if (projectData) {
            getAllCommentary()
            getAllCommentaryForExport()
            if (isOneComment) {
                //isOneComment  หมายถึงให้ UI เป็นแบบกล่องเดียวหรือหลายกล่อง
                setIsShowSubComment(false)
                const topicIsExemption = topicIsExempt.map((itm) => {
                    return { ...itm, irb: projectData?.irb }
                })
                setCommentTitleList(topicIsExemption)
            } else {
                getCommentaryTopicLut(projectData?.irb)
                setIsShowSubComment(true)
            }

            if (projectData) {
                setInitDirector(projectData.submittedID)
            }

            // if (!checkPermissionHook.isCommitteeInProject(projectData?.committeeInfo ?? []) && projectData) {
            //     setInitDirector(projectData?.submittedID)
            // } else if (checkPermissionHook.isUserChairman() && projectData) {
            //     setInitDirector(projectData?.submittedID)
            // }

            isLanguageRef.current = translate.languageStore.currentLanguage
        }
    }, [projectData?.projectID ?? null, projectData?.submittedID])

    React.useEffect(() => {
        createInitialComment()
    }, [commentTitleList, commentaryProject])

    React.useEffect(() => {
        if (projectData) {
            setInitDirector(projectData.submittedID)
        }
        // if (!checkPermissionHook.isCommitteeInProject(projectData?.committeeInfo ?? []) && projectData) {
        //     setInitDirector(projectData?.submittedID)
        // } else if (checkPermissionHook.isUserChairman() && projectData) {
        //     setInitDirector(projectData?.submittedID)
        // }
    }, [translate.languageStore.currentLanguage])

    const onRefDialogTwo = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogTwoRef.current = func
    }

    const getCommentaryProjectCommitteeByID = async (committeeUserID: number) => {
        if (projectData) {
            loadingHook.loadingOpen()
            const { result } = await callWebService.getCommentaryProjectCommitteeByID(
                projectData.submittedID,
                committeeUserID,
            )

            const showUpdater = {
                nameTH: result?.updateByNameTH,
                nameEN: result?.updateByNameEN,
                date: result?.updatedDate,
            }
            setCommentaryProject(result)
            setDataForShowUpdateDate(showUpdater)
            loadingHook.loadingClose()
        }
    }

    const checkIsDeadLine = async () => {
        const { isDeadline } = await callWebService.checkAdvisorDueDate(Number(projectData?.submittedID))
        isDeadlineRef.current = isDeadline
    }

    const getAllCommentary = async () => {
        if (projectData) {
            loadingHook.loadingOpen()
            const res = await callWebService.getAllCommentaryProjectCommittee(projectData.submittedID)
            const allCommentList = res.result.map((itm) => {
                itm.commentaryInfo.forEach((commentary) => {
                    if (commentary.name_th === null && commentary.name_en === null) {
                        commentary.name_th = 'ข้อคิดเห็น / ข้อสังเกต'
                        commentary.name_en = 'Suggestion / Notice'
                    }
                })
                return {
                    fullNameEN: itm.fullUsername_en ? itm.fullUsername_en : ' ',
                    fullNameTH: itm.fullUsername_th ? itm.fullUsername_th : ' ',
                    updatedDate: convertDateToFormatTH(itm.updatedDate),
                    updateByNameTH: itm.updateByNameTH,
                    updateByNameEN: itm.updateByNameEN,
                    approveStatusNameTH: itm.approveStatusName_th ?? '',
                    approveStatusNameEN: itm.approveStatusName_en ?? '',
                    commentaryInfo: itm.commentaryInfo.map((item) => {
                        return {
                            ...item,
                            comment_htmltag: item.comment_htmltag
                                ? item.comment_htmltag
                                      .replaceAll('<ins>', '<u>')
                                      .replaceAll('</ins>', '</u>')
                                      .replaceAll('<del>', '<s>')
                                      .replaceAll('</del>', '</s>')
                                : item.comment_htmltag,
                        }
                    }),
                }
            })
            if (allCommentList) {
                setDataSourceForCopyToClipboard(allCommentList)
            }
            loadingHook.loadingClose()
        }
    }

    const getCommentaryTopicLut = async (irb: number) => {
        if (irb) {
            const res = await callLookup.callCommentaryTopicLut(irb)

            if (res.result) {
                const formatData = res.result.map((itm: any, index: number) => {
                    return { ...itm, no: index + 1 }
                })
                setCommentTitleList(formatData)
            }
        }
    }

    const setInitDirector = async (submittedID: number) => {
        if (submittedID) {
            const { result, status } = await callLookup.callCommitteeLut(submittedID)

            if (status === 1) {
                const committeeInfo = result.map((item: any) => {
                    return {
                        director:
                            item.fullUsername_th && item.userID
                                ? {
                                      label:
                                          translate.languageStore.currentLanguage === translate.languageKey.th
                                              ? item.fullUsername_th
                                              : item.fullUsername_en,
                                      value: item.userID.toString(),
                                  }
                                : {},
                        role:
                            item?.projectRoleName_th && item?.projectRoleID
                                ? {
                                      label:
                                          translate.languageStore.currentLanguage === translate.languageKey.th
                                              ? item.projectRoleName_th
                                              : item.projectRoleName_en,
                                      value: item.projectRoleID.toString(),
                                  }
                                : {},
                    }
                })
                isCommitteeInfo.current = committeeInfo
                const directorList = committeeInfo?.map((itm: any) => {
                    return itm.director
                })

                const form = formRef.current.getState().values

                if (isCommitteeInfo.current && formRef.current) {
                    const findRole = isCommitteeInfo.current?.find(
                        (e: any) => e.director?.value === form?.director?.value,
                    )

                    if (findRole) {
                        formRef.current.change('role', findRole.role)
                    }
                }
                setDirector(directorList)

                await conditionGetCommentary(directorList)
            }
        }
    }

    const conditionGetCommentary = (director: reviewerCommentType.OptType[]) => {
        const formValueRef = formRef.current?.getState().values
        if (isLanguageRef.current === translate.languageStore.currentLanguage) {
            if (!checkPermissionHook.isUserCommittee()) {
                if (formValueRef && formValueRef.director) {
                    if (
                        profileStore?.profile.userId &&
                        checkPermissionHook.isCommitteeInProject(projectData?.committeeInfo ?? [])
                    ) {
                        getCommentaryProjectCommitteeByID(profileStore?.profile.userId)
                    } else {
                        //กรณีที่เรียกข้อมูลกรรมคนปัจจุบัน
                        getCommentaryProjectCommitteeByID(parseInt(formValueRef?.director?.value))
                    }
                    directorRef.current = formValueRef.director
                } else if (director[0]?.value) {
                    if (
                        profileStore?.profile.userId &&
                        checkPermissionHook.isCommitteeInProject(projectData?.committeeInfo ?? [])
                    ) {
                        getCommentaryProjectCommitteeByID(profileStore?.profile.userId)
                    } else {
                        getCommentaryProjectCommitteeByID(parseInt(director[0]?.value))
                        directorRef.current = director[0]
                    }
                }
            } else if (profileStore?.profile.userId) {
                getCommentaryProjectCommitteeByID(profileStore?.profile.userId)
            }
        }

        isLanguageRef.current = translate.languageStore.currentLanguage
    }

    const createInitialComment = () => {
        let commentInit: reviewerCommentType.CommentType[] = commentTitleList?.map((itm: any) => {
            return {
                topic: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                id: itm.id,
                commentList: {
                    contentHtml: itm.comment_htmltag ?? '',
                    contentText: itm.comment ?? '',
                },
                no: itm.no,
                strTheRest: 4000,
            }
        })

        if (commentaryProject?.commentaryInfo?.length === 1) {
            commentInit = commentaryProject?.commentaryInfo.map((itm: any) => {
                const countTextComment = itm.comment ? itm.comment?.length : 0
                return {
                    topic: translate.get('LABEL.SUGGESTION_NOTICE'),
                    commentList: itm.comment,
                    strTheRest: 4000 - countTextComment,
                }
            })
        } else {
            commentInit.forEach((item: any) => {
                commentaryProject?.commentaryInfo.forEach((info: reviewerCommentType.CommitteeInfoApi) => {
                    if (info.topicID === item.id) {
                        const countTextComment = info.comment.contentText ? info.comment.contentText?.length : 0
                        item.strTheRest = 4000 - countTextComment
                        item.commentList = info.comment
                        item.topic =
                            translate.languageStore.currentLanguage === translate.languageKey.th
                                ? info.topicName_th
                                : info.topicName_en
                        item.id = info.topicID
                        item.no = info.no
                    }
                })
            })
        }
        if (formRef.current) {
            formRef.current.change('commentDirector', commentInit)
            formRef.current.restart()
        }

        const textRemain = commentInit?.map((item) => {
            return item.strTheRest
        })

        setTextRemaining(textRemain)
        setInitialComment(commentInit)
        createInitialData()
        createTopicUpload()
    }

    /*function สำหรับสร้างข้อมูลเริ่มต้นในฟอร์ม */
    const createInitialData = () => {
        let initialCommittee = null

        if (isCommitteeInfo.current && isCommitteeInfo.current.length > 0) {
            if (checkPermissionHook.isCommitteeInProject(projectData?.committeeInfo ?? [])) {
                initialCommittee =
                    isCommitteeInfo.current.find(
                        (e) => Number(e.director.value) === Number(profileStore?.profile.userId),
                    ) ?? null
            } else {
                initialCommittee = isCommitteeInfo.current[0]
            }
        }

        if (commentaryProject) {
            const remark = commentaryProject.commentaryRemark
            const countStrRemark = remark ? remark.length : 0
            const textRemainingRemarkInitial = 4000 - countStrRemark
            //set ค่าเริ่มต้นฟอร์ม
            const initialData = {
                approveStatus:
                    commentaryProject && commentaryProject?.approveStatusID
                        ? {
                              label:
                                  translate.languageStore.currentLanguage === translate.languageKey.th
                                      ? commentaryProject.approveStatusName_th
                                      : commentaryProject.approveStatusName_en,
                              value: commentaryProject?.approveStatusID.toString(),
                          }
                        : null,
                isDisableFrm: false,
                submittedID: commentaryProject && commentaryProject?.submittedID,
                director: initialCommittee?.director ?? null,
                role: initialCommittee?.role ?? null,
                remark: remark ? remark : isViewMode ? '-' : null,
                comment: isShowSubComment
                    ? null
                    : commentaryProject?.commentaryInfo[0]?.comment
                    ? commentaryProject?.commentaryInfo[0]?.comment
                    : null,
                isShowUpdateDate:
                    commentaryProject && commentaryProject?.isDraft == null
                        ? false
                        : commentaryProject?.isDraft
                        ? true
                        : true,
            }

            if (formRef.current) {
                formRef.current.change('approveStatus', initialData.approveStatus)
                formRef.current.restart()
            }
            commentaryAction.setSelectedCommittedID(commentaryProject?.userID)
            setTextRemainingRemark(textRemainingRemarkInitial)
            setInitialValues(initialData)
        }
    }

    /**
     * หัวข้ออัพโหลดเอกสาร
     */
    const createTopicUpload = () => {
        const formatTopic = topicIsUploadComment.map((itm) => {
            return { ...itm, code: null, subtopic: [] }
        })
        setDocumentTopic(formatTopic)

        createInitialUploadFile(formatTopic)
    }

    /**
     *
     * การเช็ตค่าไฟล์เริ่มต้น
     */
    const createInitialUploadFile = (docTopic: ResultDocumentTopicLut[]) => {
        if (commentaryProject) {
            let documentInfo = commentaryProject.documentInfo

            const uploadFileInit = docTopic?.map((itm: any, idx: number) => {
                return {
                    uploadFileObj: {
                        fileList: [],
                        subTopicPageList: [],
                        documentTopicID: itm.id,
                    },
                }
            }) as Array<reviewerCommentType.UploadFileObjType>

            if (documentInfo && documentInfo[0]?.fileInfo.length > 0) {
                let fileList = documentInfo[0]?.fileInfo?.map((file: any) => ({
                    documentTopicID: topicIsUploadComment[0].id,
                    fileToken: file.fileToken, //fileToken
                    filename: file.filename,
                    fileID: file.fileToken, //fileToken
                    path: file.path,
                }))

                uploadFileInit[0].uploadFileObj.fileList = fileList
            }

            setInitialUploadFile(uploadFileInit)
        }
    }

    /* function สำหรับ set ข้อมูลเมื่อเลือกกรรมการคนใหม่ */
    const handleChangDirector = (val: reviewerCommentType.OptType, chang: any) => {
        if (val) {
            const formValue = formRef.current.getState().values
            let newFormValue = _.omit({ ...formValue }, ['director', 'role'])
            let initValue = _.omit(
                { ...initialValues, commentDirector: initialComment, uploadFile: initialUploadFile },
                ['director', 'role'],
            )

            const isEqual = _.isEqual(initValue, newFormValue)

            if (director.length > 1) {
                if (
                    !isEqual &&
                    (commentaryProject?.isDraft || commentaryProject?.isDraft === null) &&
                    !isDirectorEmptyRef.current
                ) {
                    chang('director', directorRef.current)
                    setConfigDialog({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        content: translate.get('ALERT.CONTENT.CONFIRM_CHANGE_DIRECTOR'),
                        type: 'alert-confirm',
                        onClickConfirm: () => {
                            if (showSaveDraft) {
                                //บันทึกร่าง
                                paramsRef.current = { ...newFormValue, director: directorRef.current }
                                const parameter = getParameterForSave(paramsRef.current)
                                if (parameter) {
                                    parameter.isDraft = true
                                    handleConfirmSave(parameter)
                                }
                            }
                            isCommitteeInfo.current.forEach((itm: any) => {
                                if (val === itm.director) {
                                    chang('role', itm.role)
                                    chang('director', itm.director)
                                    directorRef.current = itm.director
                                }
                            })
                            dialogTwoRef.current?.closeDialog()
                            getCommentaryProjectCommitteeByID(parseInt(val.value))
                        },
                    })
                    dialogTwoRef.current?.openDialog()
                } else {
                    isCommitteeInfo.current.forEach((itm: any) => {
                        if (val === itm.director) {
                            chang('role', itm.role)
                            directorRef.current = itm.director
                        }
                    })
                    if (val?.value) {
                        getCommentaryProjectCommitteeByID(parseInt(val?.value))
                    }
                }
                isDirectorEmptyRef.current = false
            }
        } else {
            isDirectorEmptyRef.current = true
        }
    }

    /* function สำหรับ set ข้อมูลเมื่อเลือกผลพิจารณา */
    const handleChangStatus = (val: reviewerCommentType.OptType) => {}

    const handleChangTextField = (val: string, idex: number) => {
        if (textRemaining?.length > 0) {
            textRemaining[idex] = 4000 - val.length
        }
    }

    const handleChangRemark = (val: string) => {
        if (textRemainingRemark) {
            setTextRemainingRemark(4000 - val.length)
        }
    }

    /**
     * process for save
     */

    const handleClickCancel = (dirty: boolean) => {
        if (dirty) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.WARNING'),
                content: translate.get('ALERT.CONTENT.NEED_TO_CANCEL'),
                type: 'alert-confirm',

                onClickConfirm: () => {
                    history.push(RoutePath.manageProject)
                },
            })
            dialogTwoRef.current?.openDialog()
        } else {
            history.push(RoutePath.manageProject)
        }
    }

    const handleSubmitForm = async (val: any) => {
        const isAutoSave = !!val?.autoSave
        const parameter = getParameterForSave(val)
        if (isAutoSave) {
            formRef.current?.change?.('autoSave', false)
        }
        if (val.submitType === 'save') {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
                type: 'alert-confirm',
                onClickConfirm: () => {
                    handleConfirmSave(parameter)
                },
            })
            dialogTwoRef.current?.openDialog()
        } else {
            //ถ้า save draft ไม่ต้องมี alert confirm
            handleConfirmSave(parameter)
        }
    }
    const getParameterForSave = (val: any): any => {
        if (projectData && val) {
            let isDraft = false
            if (val.submitType === 'draft') {
                isDraft = true
            }
            const commentaryInfo = val?.commentDirector?.map((item: any) => {
                return {
                    topicID: item && item?.id ? item?.id : null,
                    contentHtml: item && item?.commentList?.contentHtml ? item?.commentList?.contentHtml : null,
                    contentText: item && item?.commentList?.contentText ? item?.commentList?.contentText : null,
                }
            })
            const commentaryProjectRequest: CommentaryProjectType = {
                loginUserID: profileStore.profile.userId,
                submittedID: projectData?.submittedID,
                committeeUserID:
                    profileStore.profile.userGroupId === constUserGroup.officer
                        ? val && val.director && val.director.value
                            ? parseInt(val?.director.value)
                            : null
                        : profileStore.profile.userId,
                approveStatusID:
                    val && val.approveStatus && val.approveStatus.value ? parseInt(val?.approveStatus.value) : null,
                commentaryRemark: val && val.remark ? val.remark : null,
                commentaryInfo: commentaryInfo ? commentaryInfo : [],
                documentInfo: getDocumentInfo(val),
                isDraft: isDraft,
                isAutoSave: val?.autoSave ? val.autoSave : false,
            }
            return commentaryProjectRequest
        }
    }

    const getDocumentInfo = (val: any) => {
        let fileDataList = val.uploadFile.filter((itm: any) => itm.uploadFileObj.fileList.length > 0)
        let myFileData: Array<REQServiceTypes.DocumentInfo> = []

        fileDataList.forEach((uploadObj: reviewerCommentType.UploadFileObjType) => {
            const subTopicLst = uploadObj?.uploadFileObj.subTopicPageList?.map((subtopic) => {
                return {
                    subtopicID: subtopic.subtopicID,
                    page: subtopic.page,
                }
            })

            // const fileTokenInfo: Array<string> = uploadObj.uploadFileObj.fileList?.map((file) => file.fileToken) ?? []
            const fileTokenInfo: Array<{
                replaceFileID: number
                fileToken: string
                fileExtension?: string
                fileID: any
            }> =
                uploadObj.uploadFileObj.fileList?.map((file) => {
                    return {
                        //@ts-ignore
                        replaceFileID: file?.replaceFileID ? file.replaceFileID : null,
                        fileToken: file.fileToken,
                        fileExtension: file.filename.split('.').pop(),
                        fileID: file?.fileID ? file.fileID : null,
                    }
                }) ?? []

            myFileData.push({
                documentTopicID: uploadObj?.uploadFileObj?.documentTopicID,
                fileTokenInfo: fileTokenInfo,
                subtopic: subTopicLst && subTopicLst.length > 0 ? subTopicLst : [],
            })
        })

        return myFileData
    }

    const handleConfirmSave = async (
        paramForSave: any,
        tabIndex: number | null = null,
        newTabSelected: TabSelectedType | null = null,
        isFolder?: boolean,
    ) => {
        dialogTwoRef.current?.closeDialog()
        const isDraft = paramForSave.isDraft ? paramForSave.isDraft : false
        const isAutoSave = !!paramForSave?.isAutoSave
        loadingHook.loadingOpen()
        const res = await callWebService.commentaryProject(paramForSave)

        const res2 = await callWebService.submitAllCheckList({
            ...checklistState,
            submittedID: projectData?.submittedID ?? 0,
            committeeID: paramForSave.committeeUserID,
        })
        if (res2?.status === 1) {
            clearChecklist()
        } else {
            console.error('submitAllCheckList failed:', res2?.message)
            appAlertMessageAction.openAlertMessage({
                title: translate.get('ALERT.TITLE.ERROR'),
                message: translate.get('ALERT.CONTENT.SAVE_NOT_SUCCESS'),
            })
            loadingHook.clearLoading()
            return
        }
        if (!isFolder) {
            //if นี้จะเช็คว่าเป็นการติด dirty จากการกดเปลี่ยน folder ใช่หรือไม่?
            if (tabIndex && newTabSelected) {
                //if นี้จะเช็คว่าเป็นการติด dirty จากการกดเปลี่ยน Tab ใช่หรือไม่?
                tabAndFolderHook.setTab(tabIndex, newTabSelected)
            } else {
                //หากเข้า else หมายความว่าเป็นการบันทึกจากกดปุ่มบันทึกไม่ใช่จากการติด dirty
                if (callbackSaveComplete && !isAutoSave) {
                    if (res && res.status) {
                        callbackSaveComplete(res.status, isDraft)
                    }
                    if (res && res.status === 1) {
                        const formValue = formRef.current.getState().values

                        if (
                            profileStore?.profile.userId &&
                            checkPermissionHook.isCommitteeInProject(projectData?.committeeInfo ?? [])
                        ) {
                            getCommentaryProjectCommitteeByID(profileStore?.profile.userId)
                        } else {
                            if (formValue && profileStore.profile.userId) {
                                const directorID =
                                    formValue && formValue.director
                                        ? parseInt(formValue.director.value)
                                        : profileStore.profile.userId
                                getCommentaryProjectCommitteeByID(directorID)
                            }
                        }
                    }
                }
            }
        }
        loadingHook.loadingClose()
    }

    /**
     *
     * Dirty
     */
    const handleDirtyChange = (props: { values: any }) => {
        let isDirty: boolean = false
        latestFormValuesRef.current = props.values
        paramsRef.current = { ...props.values }
        //** ตอน checkdirty จะไม่สนใจ รายชื่อกรรมการและหน้าที่  **//
        let newFormValue = _.omit({ ...props.values }, ['director', 'role'])
        let initValue = _.omit({ ...initialValues, commentDirector: initialComment, uploadFile: initialUploadFile }, [
            'director',
            'role',
        ])
        //**********************************************************//
        const isEqual = _.isEqual(newFormValue, initValue) //ข้อมูลเท่ากัน

        if (!isViewMode && !initialValues?.isDisableFrm) {
            if (isEqual) {
                isDirty = false
            } else {
                isDirty = true
            }
        }

        // paramsRef.current = getParameterForSave(props.values)

        const paramsDirty = {
            tabDirty: isDirty,
            callbackDirty: callbackDirtyProcess,
        }
        appFolderAndTabAction.setDirty(paramsDirty)
    }

    const callbackDirtyProcess = (
        tabIndex: number | null = null,
        newTabSelected: TabSelectedType | null = null,
        isFolder?: boolean,
    ) => {
        const parameter = getParameterForSave(paramsRef.current)
        if (parameter) {
            parameter.isDraft = true
            handleConfirmSave(parameter, tabIndex, newTabSelected, isFolder)
        }
    }

    const checkIsDisplayCopyToClipboard = () => {
        let isDisplayCopyToClipboard = false
        if (projectData) {
            if (projectData?.stepID > submittedStep.commentary) {
                isDisplayCopyToClipboard = true
            } else {
                isDisplayCopyToClipboard = false
            }
        }
        return isDisplayCopyToClipboard
    }

    const handleClickBackToSearch = () => {
        history.push(RoutePath.manageProject)
    }

    const isGerneralCommittee = (lstCommitteeInProject: GetProjectResultType['committeeInfo']) => {
        let isValid = false
        const generalCommitteeIdx = lstCommitteeInProject.find((itm) => {
            return itm.userID === profileStore.profile.userId
        })
        if (generalCommitteeIdx) {
            isValid = generalCommitteeIdx.projectRoleInfo.value === committeeProjectRole.committee
        }

        return isValid
    }

    const getAllCommentaryForExport = async () => {
        if (projectData) {
            const { result } = await callWebService.getHistoryCommentaryProjectCommittee(projectData?.submittedID)
            const allCommentList = result.map((itm) => {
                if (itm.commentary.length === 1) {
                    itm.commentary.forEach((comment) => {
                        comment.nameTopicTH1 = 'ข้อคิดเห็น / ข้อสังเกต'
                        comment.nameTopicEN1 = 'Suggestion / Notice'
                        comment.nameTopicTH2 = 'ข้อคิดเห็น / ข้อสังเกต'
                        comment.nameTopicEN2 = 'Suggestion / Notice'
                    })
                }
                if (itm.historyCommentary.length === 1) {
                    itm.historyCommentary.forEach((comment) => {
                        comment.nameTopicTH1 = 'ข้อคิดเห็น / ข้อสังเกต'
                        comment.nameTopicEN1 = 'Suggestion / Notice'
                        comment.nameTopicTH2 = 'ข้อคิดเห็น / ข้อสังเกต'
                        comment.nameTopicEN2 = 'Suggestion / Notice'
                    })
                }

                return {
                    userID: itm.userID,
                    fullUsername_en: itm.fullUsername_en,
                    fullUsername_th: itm.fullUsername_th,
                    commentary: itm.commentary,
                    updatedDate: itm.updatedDate,
                    updateByNameTH: itm.updateByNameTH,
                    updateByNameEN: itm.updateByNameEN,
                    approveStatusName_th: itm.approveStatusName_th,
                    approveStatusName_en: itm.approveStatusName_en,
                    approveStatusID: itm.approveStatusID,
                    historyCommentary: itm.historyCommentary,
                }
            })
            setDataSourceForExport(allCommentList)
        }
    }

    const handleAutoSave = async (values: any) => {
        if (!showSaveDraft) return

        try {
            const latestValues = latestFormValuesRef.current ?? formRef.current?.getState?.()?.values ?? values
            const latestChecklistState = checklistStateRef.current
            const hasCommentData = (latestValues?.commentDirector ?? []).some((item: any) => {
                const comment = item?.commentList
                return Boolean(comment?.contentHtml?.trim() || comment?.contentText?.trim())
            })
            const hasRemark = Boolean(latestValues?.remark?.trim?.())
            const hasChecklistData = latestChecklistState.checklist.length > 0

            if (hasAutoSavedDataRef.current && !hasCommentData && !hasRemark && !hasChecklistData) return

            const paramForSave = getParameterForSave({
                ...latestValues,
                submitType: 'draft',
                autoSave: true,
            })
            await callWebService.commentaryProject(paramForSave, true) //silent = true กัน dialog เด้งตอน autosave พลาด ผู้ใช้ไม่ได้กดบันทึกเอง

            if (hasChecklistData) {
                await callWebService.submitAllCheckList(
                    {
                        ...latestChecklistState,
                        submittedID: projectData?.submittedID ?? 0,
                        committeeID: paramForSave.committeeUserID,
                        isAutoSave: true,
                    },
                    true,
                )
            }

            hasAutoSavedDataRef.current = hasCommentData || hasRemark || hasChecklistData
        } catch (error) {
            console.error(error)
        }
    }

    return {
        role: [],
        director,
        isViewMode,
        isCommittee: checkPermissionHook.isCommitteeInProject(projectData?.committeeInfo ?? []),
        isUserChairman: checkPermissionHook.isUserChairman(),
        isDeadlineOfGeneralCommittee:
            checkPermissionHook.isCommitteeInProject(projectData?.committeeInfo ?? []) &&
            isGerneralCommittee(projectData?.committeeInfo ?? []) &&
            isDeadlineRef.current,
        initialValues,
        commentTitleList,
        initialComment,
        configDialog,
        formRef,
        isShowSubComment,
        isRequired,
        textRemaining,
        textRemainingRemark,
        dataSourceForCopyToClipboard,
        documentTopic,
        initialUploadFile,
        isDisplayCopyToClipboard: checkIsDisplayCopyToClipboard(),
        projectData,
        showSaveDraft,
        onDirtyChange: handleDirtyChange,
        onChangeDirector: handleChangDirector,
        onChangStatus: handleChangStatus,
        onRefDialogTwo,
        onChangTextField: handleChangTextField,
        onChangRemark: handleChangRemark,
        onClickCancel: handleClickCancel,
        onSubmitForm: handleSubmitForm,
        onAutoSave: handleAutoSave,
        onClickBackToSearch: handleClickBackToSearch,
        dataSourceForExport,
        dataForShowUpdateDate,
    }
}

export default useReviewerComment
